module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3093350d47951f7522e6358069c4a8b7.png";